import INVENTORY_TOOLTIPS from 'domains/inventory/molecules/view/inventory-tooltip-content'
import { UncontrolledTooltip } from 'reactstrap'
import PropTypes from 'prop-types'

const propTypes = {
  label     : PropTypes.string,
  value     : PropTypes.any,
  tooltipId : PropTypes.string
}

const InventoryViewRow = ({ label, value, tooltipId }) => (
  <tr>
    <th scope='row'>
      { label }
      {
        tooltipId && (
          <>
            <i
              className='fas fa-info-circle ml-2 text-info'
              id={ `tooltip-${tooltipId}` }
            />
            <UncontrolledTooltip
              innerClassName='text-left'
              placement={ 'right' }
              target={ `tooltip-${tooltipId}` }
            >
              { INVENTORY_TOOLTIPS[tooltipId] }
            </UncontrolledTooltip>
          </>
        )
      }
    </th>
    <td>{ value ? value : '-' }</td>
  </tr>
)

InventoryViewRow.propTypes = propTypes

export default InventoryViewRow